import React, { Component } from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { Chart } from 'react-chartjs-2';
import { ThemeProvider } from '@material-ui/styles';
import validate from 'validate.js';

import { chartjs } from './helpers';
import theme from './theme';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './assets/scss/index.scss';
import validators from './common/validators';
import Routes from './Routes';

import {DataProvider} from './data'

const browserHistory = createBrowserHistory();

Chart.helpers.extend(Chart.elements.Rectangle.prototype, {
  draw: chartjs.draw
});

validate.validators = {
  ...validate.validators,
  ...validators
};

const data = new DataProvider({history: browserHistory});

export const DataService = React.createContext();

export default class App extends Component {
  render() {
    return (
      <DataService.Provider value={data}>
        <ThemeProvider theme={theme}>
          <Router history={browserHistory}>
            <Routes  />
          </Router>
        </ThemeProvider>
      </DataService.Provider>
    );
  }
}
